import React, { useState, useEffect } from 'react'
import StarIcon from '@mui/icons-material/Star';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CancelIcon from '@mui/icons-material/Cancel';
import PersonIcon from '@mui/icons-material/Person';
import StairsIcon from '@mui/icons-material/Stairs';
import WorldIcon from '@mui/icons-material/Language';
import Status from '../../Components/Status/Status';
import { Oval } from 'react-loader-spinner';
// import ProgressBar from "@ramonak/react-progress-bar";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import axios from 'axios';
import { useQuery } from 'react-query';
import { baseUrl, path } from '../../constants';
import { Link } from 'react-router-dom';
import Preview from '../Preview/Preview';
import {api} from '../../api'


export default function Courses() {
    const { isLoading, error, data , refetch} = useQuery('fetchCourses', () => api(path.getCourses, {}) )
    const [selectedCourse, setSelectedCourse] = useState(null)
    const [query, setQuery] = useState('')
    const [courseId, setCourseId] = useState(null)
    
  return ( 
  <div className='flex flex-col flex-1 overflow-auto gap-4'>
    <Status title={'My Courses'} action={{link: '/add-course', title: 'Create New Course'}} />
    {isLoading ? (
        <div className='flex flex-col items-center gap-3'>
            <p className='text-black text-[15px]'>Loading data...</p>
            <Oval
                visible={true}
                height="30"
                width="30"
                color="#52a4e0"
                secondaryColor="#ffffff"
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
                strokeWidth={3}
                />
        </div>
    ) :
            <div className='flex flex-col bg-white rounded-sm flex-1 overflow-y-auto'>
                <div className='flex items-center justify-between p-2'>
                    <div className='flex gap-4 items-center'>
                        <div className='flex h-[40px] w-[300px] max-md:w-[150px] relative border-solid border-[#0000007f] border-[1px]'>
                            <input onChange={e => setQuery(e.target.value)} placeholder='Search courses...' className='h-full w-full pl-5' />
                        </div>
                    </div>
                    {/* <button className='px-5 py-2 bg-main text-white text-[12px] font-bold outline-none border-none bg-none'>Export Data</button> */}
                </div>
                {!data?.data?.courses?.length && <p className='text-center opacity-75'>You have no courses yet! Start Now</p>}
                <div className='grid grid-cols-3 max-md:grid-cols-1 gap-x-7 gap-y-7 flex-1 p-2 overflow-y-auto'>
                    {data?.data?.courses?.filter(c => new RegExp(query, 'gi').test(c.title)).map(course => (
                        <CourseCard course={course} setSelectedCourse={setSelectedCourse} setCourseId={setCourseId} />
                    ))}
                </div>
            </div>}
        {selectedCourse && <Preview refetch={refetch} courseId={selectedCourse} setSelectedCourse={setSelectedCourse} selectedCourse={selectedCourse} />}
        {courseId && <Ratings courseId={courseId} setCourseId={setCourseId} />}
    </div>
  )
}

export const getRating = (rates=[]) => {
    let length = rates.length
    let total = rates.reduce((ac, cu) => ac + cu.rating?.value, 0)
    return (total / length) 
}

export function CourseCard({course, setCourseId, setSelectedCourse}) {
  return (
    <div href='/' to={'/course/232323'} className='bg-white flex border-[1px] border-[#00000060] flex-col p-2 gap-2 shadow-md hover:shadow-xl hover:border-main group transition-all cursor-pointer rounded-md'>
        <img className='rounded-md h-1/2 w-full object-cover' src={baseUrl + course.thumbnail} alt='course' />
        <p className='text-black text-md font-bold text-center'>{course.title}</p>
        <p className='text-black text-sm'>{course.price.toFixed(0)} ETB</p>
        <div className='flex items-center gap-1'>
            <p className='text-black text-xs'>{course.value}</p>
            <StarIcon style={{color: 'black', fontSize: 12}}>Filled</StarIcon>
            <p className='text-black text-xs'>{course.rates.length ? 'Rating: ' + getRating(course.rates) : 'No Rating'}</p>
            {!!course.rates.length && <button onClick={() => setCourseId(course.id)} className='bg-black text-white text-[10px] ml-2 font-bold px-3 py-1 rounded-md'>View Ratings</button>}
        </div>
        <hr />  
        <div className='flex justify-between p-2 items-center'>
            <div className='flex items-center gap-2'>
                <PeopleAltIcon style={{color: '#000000', fontSize: 12}}>Filled</PeopleAltIcon>
                <p className='text-black text-xs'>{course.enrollCount} Enrolled</p>
            </div>
            <div className='flex items-center gap-2'>
                <WorldIcon style={{color: '#000000', fontSize: 12}}>Filled</WorldIcon>
                <p className='text-black text-xs'>{course.languages?.split(';')?.at(0)}</p>
            </div>

            <div className='flex items-center gap-2'>
                <StairsIcon style={{color: '#000000', fontSize: 12}}>Filled</StairsIcon>
                <p className='text-black text-xs'>{course.level}</p>
            </div>
        </div>
        <div className='flex flex-col w-full gap-[7px] p-[7px]'>
            <Link to={`/course-sections/${course.id}`} className='p-1 w-full  self-center rounded-md bg-main text-white no-underline text-md text-center font-bold'>Course Sections</Link>
            <Link to={`/edit-course/${course.id}`} className='p-1 w-full  self-center rounded-md bg-main text-white no-underline text-md text-center font-bold'>Edit Course</Link>
            <button onClick={() => setSelectedCourse(course)} className='p-1 w-full  self-center rounded-md bg-main text-white no-underline text-md text-center font-bold'>Video Preview</button>
        </div>
        
    </div>
  )
}

function Ratings({ courseId, setCourseId}){
    const [loading, setLoading] = useState(true)
    const [ratings, setRatings] = useState([])


    useEffect(() => {
        api.get(path.ratings + '/' + courseId).then(response => {
            let data = response.data
            if(data.success){
                setRatings(data.ratings)
            }
        }).finally(() => setLoading(false))
    }, [])

    return (
        <div className='fixed inset-0 bg-[#00000070] flex items-center justify-center z-[99999]'>
            <div className='flex flex-col bg-white p-4 max-md:w-[80%] relative rounded-md gap-5'>
                <h1 className='text-lg font-bold text-center'>Ratings</h1>
                {loading && (
                        <div className='flex flex-col gap-3 flex-1 items-center p-5 justify-center self-center'>
                            <p className='text-[16px]'>Loading...</p>
                            <Oval
                                visible={true}
                                height="30"
                                width="30"
                                color="#198754"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                strokeWidth={3}
                            />
                        </div>
                ) }
                <div className='grid grid-cols-4 gap-3 max-md:grid-cols-1'>
                {ratings.map(rate => (
                    <div className='flex flex-col gap-2 border-[1px] border-[#00000030] rounded-md p-2'>
                        <div className='flex items-center gap-3'>
                            <div className='w-[40px] h-[40px] bg-[#00000030] flex items-center justify-center rounded-full'>
                                <PersonIcon style={{color: '#000000', fontSize: 14}}>Filled</PersonIcon>
                            </div>
                            <div className=''>
                                <h1>{rate.firstName} {rate.lastName}</h1>
                                <p className='font-bold text-main'>{rate.rating?.value} stars</p>
                            </div>
                        </div>
                        <p className='mt-4 text-sm text-justify'>
                            {rate.rating?.comment}
                        </p>
                    </div>
                ))}
                    {/*  */}
                </div>
                <button onClick={() => setCourseId(null)} className='absolute outline-none bg-white rounded-full bg-none -top-4 -right-4 flex items-center justify-center'>
                    <CancelIcon style={{fontSize: 25, color: '#000000'}}>Filled</CancelIcon>
                </button>
            </div>
        </div>
    )
}